module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAArCAMAAADmD5DTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF2uri0ebc6OjpyNHM6vLtzd3W8/Tz4e/nytfQ2tzbzuHY/Pz85OTl0dHR////3u7p6/x8ggAAAPBJREFUeNq01duShCAMBNAORgQv5P//dgLrXNUaeqq2H3w7FWigRGGD+llmYNJICLUaiLvvsInJXgIR2KTaL+6Ri5FNwK6DXWq3OMxsQqw/qCKCFUoAE1xVdZWRFgm9Vb2tihdMuTaDLNcyyHLbeUy0oIAEsFUpyKok/iK4qkZeLCDLHf3V4p9FciHcCf4iuKrqPriqLNPCmwItyI2HgnUY0jgLei9iQd5a3PXAKra3fIOzixjWvH1mqEt1KcfL/vf/KEvUkI9wn1kp7ge4iz1LDOewTXWc0od4QPWlnstz8ZRtZu4Xz8RqfWxeS7kJMADWAnBPgkFpzAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/CO.png
// module id = Y7AL
// module chunks = 1